// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"80cd44d8","239":"73b3d524","453":"bf86a8d6","455":"0d16612f"}[chunkId] + ".chunk.js";
};